(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  let title = document.querySelector('.product-single__title');
  let newTitle = title.innerHTML.replace('®', '<sup>&reg;</sup>');
  title.innerHTML = newTitle;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-material-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener('page:loaded', function() {
  var elem = document.querySelector('.material-slider_container');
  var flkty = new Flickity( elem, {
  // options
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    wrapAround: true
  });
});

  } catch(e) { console.error(e); }
})();
      })();
